/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createChargerDefinitionDocumentSummaryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type ChargerDefinitionDocumentSummary, type ChargerDefinitionDocumentType, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { MultipartBody, serializeMultipartBody, type BaseRequestBuilder, type Guid, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /chargerdefinitions/{chargerDefinition-id}/documents
 */
export interface DocumentsRequestBuilder extends BaseRequestBuilder<DocumentsRequestBuilder> {
    /**
     * GetChargerDefinitionDocuments
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ChargerDefinitionDocumentSummary[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ChargerDefinitionDocumentSummary[] | undefined>;
    /**
     * UploadChargerDefinitionDocument
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: MultipartBody, requestConfiguration?: RequestConfiguration<DocumentsRequestBuilderPostQueryParameters> | undefined) : Promise<Guid | undefined>;
    /**
     * GetChargerDefinitionDocuments
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * UploadChargerDefinitionDocument
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: MultipartBody, requestConfiguration?: RequestConfiguration<DocumentsRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
/**
 * UploadChargerDefinitionDocument
 */
export interface DocumentsRequestBuilderPostQueryParameters {
    type?: ChargerDefinitionDocumentType;
}
/**
 * Uri template for the request builder.
 */
export const DocumentsRequestBuilderUriTemplate = "{+baseurl}/chargerdefinitions/{chargerDefinition%2Did}/documents";
/**
 * Metadata for all the requests in the request builder.
 */
export const DocumentsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: DocumentsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createChargerDefinitionDocumentSummaryFromDiscriminatorValue,
    },
    post: {
        uriTemplate: "{+baseurl}/chargerdefinitions/{chargerDefinition%2Did}/documents?type={type}",
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "multipart/form-data",
        requestBodySerializer: serializeMultipartBody,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
